let ancho = get_browser_width();

require('./common/custom/searcher.js');
require('./common/custom/scrolltop.js');

function datesSearcher(d, startDate = null, endDate = null, force_endDate = false){

    //Para garantizar que hay valores para inicializar los calendarios
    if((startDate == '' || endDate == '') || force_endDate){
        var day_start = d.getDate()  < 10 ? '0' + d.getDate()  : d.getDate();
        var month_start = (d.getMonth() + 1)  < 10 ? '0' + (d.getMonth() + 1)  : (d.getMonth() + 1);
        var minDate = day_start + "/" + month_start + "/" + d.getFullYear();

        var d_end = d;
        d_end.setDate(d_end.getDate() + 2);
        var day_end = d_end.getDate()  < 10 ? '0' + d_end.getDate()  : d_end.getDate();
        var month_end = (d_end.getMonth() + 1)  < 10 ? '0' + (d_end.getMonth() + 1)  : (d_end.getMonth() + 1);
        endDate = day_end + "/" + month_end + "/" + d_end.getFullYear();
    }

    var dates = [minDate, endDate];

    return dates;

}

function updateDatePickerTextDesktop(focus = true, only_desktop = false){

    if(focus){

        if(only_desktop){
            $('input[data-name="datePickerTextDesktop"]').focus();
        }else{
            if(ancho <= 576){
                $('input[data-name="datePickerTextMobile"]').focus();
            }else{
                $('input[data-name="datePickerTextDesktop"]').focus();
            }
        }

    }

    var originalText = '';
    var txt_datapicker = $('input[name="datapicker"]').val();
    var txt_datapickerOut = $('input[name="datapickerOut"]').val();

    if($('input[name="tipoP"]').val() != ''){
        originalText = txt_datapicker;
    }else{
        originalText = (txt_datapicker != '' && txt_datapickerOut != '')? txt_datapicker + ' - ' + txt_datapickerOut : '';
    }

    var replacedText = originalText.replace(/\./g,'');

    if(only_desktop){
        $('input[data-name="datePickerTextDesktop"]').val(replacedText);
    }else{
        if(ancho <= 576){
            $('.searcher-dates').text(replacedText);
            $('input[data-name="datePickerTextMobile"]').val(replacedText);
            if ($("#slopes-search-date")[0]) {
                txt_datapicker_no_year = txt_datapicker.substr(0, txt_datapicker.lastIndexOf("/"));
                txt_datapickerOut_no_year = txt_datapickerOut.substr(0, txt_datapickerOut.lastIndexOf("/"));
                $("#slopes-search-date").text(txt_datapicker_no_year + ' - ' + txt_datapickerOut_no_year);
            }
        }else{
            $('input[data-name="datePickerTextDesktop"]').val(replacedText);
        }
    }

}

function startDateRangePickerSearcher(moda,destroy){

    //Definimos la culture
    moment.locale(LOCALE);

    var d = new Date();
    var d_now = new Date();
    var startDate = '';
    var endDate = '';
    var singleDatePicker = false;

    if(moda == 'T'){
        singleDatePicker = true;
    }

    if($('input[name="startDateIn"]').val() != '' && $('input[name="startDateOut"]').val() != ''){
        startDate = $('input[name="startDateIn"]').val();
        endDate = $('input[name="startDateOut"]').val();
    }else if($('input[name="datapicker"]').val() != '' && $('input[name="datapickerOut"]').val() != ''){
        startDate = $('input[name="datapicker"]').val();
        endDate = $('input[name="datapickerOut"]').val();
    }

    //Forzar la fecha del buscador en landings de esqui entre Noviembre y Abril
    if(moda == 'E' && d.getMonth() > 3 && d.getMonth() < 10){

        d = new Date(d.getFullYear(), 10, 1);
        $('input[name="startDateIn"]').val($('input[name="datapicker"]').val());
        $('input[name="startDateOut"]').val($('input[name="datapickerOut"]').val());

        var txt_datapicker = $('input[name="datapicker"]').val();
        array_datapicker = (txt_datapicker != '')? txt_datapicker.split('/') : null;

        if(moda == 'E' && array_datapicker != null && array_datapicker[1] > 4 && array_datapicker[1] < 11){
            startDate = '';
            endDate = '';
        }else{
            startDate = $('input[name="datapicker"]').val();
            endDate = $('input[name="datapickerOut"]').val();
        }

    }else{

        if($('input[name="startDateIn"]').val() != '' && $('input[name="startDateOut"]').val() != ''){
            $('input[name="datapicker"]').val($('input[name="startDateIn"]').val());
            $('input[name="datapickerOut"]').val($('input[name="startDateOut"]').val());
        }

        $('input[name="startDateIn"]').val('');
        $('input[name="startDateOut"]').val('');

    }

    var day_start = d.getDate()  < 10 ? '0' + d.getDate()  : d.getDate();
    var month_start = (d.getMonth() + 1)  < 10 ? '0' + (d.getMonth() + 1)  : (d.getMonth() + 1);
    var minDate = day_start + "/" + month_start + "/" + d.getFullYear();

    var dates = datesSearcher(d,startDate,endDate);
    startDate = (dates[0])?dates[0]:startDate;
    endDate = (dates[1])?dates[1]:endDate;

    //Forzar la fecha del buscador en landings de esqui entre Noviembre y Abril
    if(moda == 'E' && d_now.getMonth() > 3 && d_now.getMonth() < 10){
        if($('input[name="startDateIn"]').val() == '' && $('input[name="startDateOut"]').val() == ''){

            var dates_now = datesSearcher(d_now,null,null,true);
            startDate_now = dates_now[0];
            endDate_now = dates_now[1];

            $('input[name="startDateIn"]').val(startDate_now);
            $('input[name="startDateOut"]').val(endDate_now);
        }

        minDate = "01/06/" + d.getFullYear();
    }

    $('input[name="datapicker"]').val(startDate);
    $('input[name="datapickerOut"]').val(endDate);

    if(destroy){
        $('input[data-name="datePickerTextDesktop"]').daterangepicker('destroy');
        $('input[data-name="datePickerTextMobile"]').daterangepicker('destroy');
    }

    //Inicializamos el datepicker
    $('input[data-name="datePickerTextDesktop"]').daterangepicker({
        "autoUpdateInput": true,
        "singleDatePicker": singleDatePicker,
        "minDate": minDate,
        "maxSpan": {
            "days": 7
        },
        "autoApply": true,
        "locale": {
          "format": 'DD/MM/YYYY',
        },
        "isInvalidDate": function(date) {
            if (moda == 'E' && ((date.format('MM') > '08' && date.format('MM') < '11'))) {
                return true;
            }
        },
        "startDate": startDate,
        "endDate": endDate,

    }, function(start, end, label) {

        if (start.format('DD/MM/YYYY') != end.format('DD/MM/YYYY') || (start.format('DD/MM/YYYY') == end.format('DD/MM/YYYY') && moda == 'T')) {

            $('input[name="datapicker"]').val(start.format('DD/MM/YYYY'));
            $('input[name="datapickerOut"]').val(end.format('DD/MM/YYYY'));

            if(moda == 'E'){
                $('input[name="startDateIn"]').val(start.format('DD/MM/YYYY'));
                $('input[name="startDateOut"]').val(end.format('DD/MM/YYYY'));
            }

        }else {
            startDateRangePickerSearcher(moda,true);
            $('#equalDatesErrorModal').modal('show');
        }

    });

    $('input[data-name="datePickerTextDesktop"]').on('apply.daterangepicker', function(ev, picker) {
        updateDatePickerTextDesktop(false);
    });

    $('input[data-name="datePickerTextMobile"]').daterangepicker({
        "autoUpdateInput": true,
        "singleDatePicker": singleDatePicker,
        "applyButtonClasses": "btn btn-custom-lg bg-custom-secondary text-white",
        "minDate": minDate,
        "maxSpan": {
            "days": 7
        },
        "autoApply": false,
        "locale": {
            "format": 'DD/MM/YYYY',
            "applyLabel": translations.accept,
            "cancelLabel": translations.cancel,
        },
        "isInvalidDate": function(date) {
            if (moda == 'E' && ((date.format('MM') > '08' && date.format('MM') < '11'))) {
                return true;
            }
        },
        "startDate": startDate,
        "endDate": endDate,

    }, function(start, end, label) {

        if (start.format('DD/MM/YYYY') != end.format('DD/MM/YYYY') || (start.format('DD/MM/YYYY') == end.format('DD/MM/YYYY') && moda == 'T')) {

            $('input[name="datapicker"]').val(start.format('DD/MM/YYYY'));
            $('input[name="datapickerOut"]').val(end.format('DD/MM/YYYY'));

            if(moda == 'E'){
                $('input[name="startDateIn"]').val(start.format('DD/MM/YYYY'));
                $('input[name="startDateOut"]').val(end.format('DD/MM/YYYY'));
            }

        }else {
            startDateRangePickerSearcher(moda,true);
            $('#equalDatesErrorModal').modal('show');
        }

    });

    $('input[data-name="datePickerTextMobile"]').on('apply.daterangepicker', function(ev, picker) {
        updateDatePickerTextDesktop(false);
    });

    //Por defecto ocultamos la fecha de los botones
    $('.drp-selected').hide();

    // Añadir preload al buscador mobile minimalista
    if (!!startDate && !!endDate) {
        let [startDay, startMonth, startYear] = startDate.split("/").map(Number);
        let formattedStartDate = new Date(startYear, startMonth - 1, startDay);
        let [endDay, endMonth, endYear] = endDate.split("/").map(Number);
        let formattedEndDate = new Date(endYear, endMonth - 1, endDay);

        let options = { weekday: 'short', day: '2-digit', month: 'short' };

        formattedStartDate = new Intl.DateTimeFormat('es-ES', options).format(formattedStartDate);
        formattedEndDate = new Intl.DateTimeFormat('es-ES', options).format(formattedEndDate);

        originalText = (formattedStartDate != '' && formattedEndDate != '')? formattedStartDate + ' - ' + formattedEndDate : '';
        var replacedText = originalText.replace(/\./g,'');
        if (!!replacedText) {
            $('.searcher-dates').text(replacedText);
        }
    }
}

//Iniciamos los calendarios del buscador
var moda = $('input[name="moda"]').val();
startDateRangePickerSearcher(moda,false);

//Mostramos el aviso de que la fecha o el destino no pueden estar vacios
$('#searchHousingForm').submit(function(){

    var error=0;

    if ($('input[name="zona"]').val() == 0 && $('input[name="area"]').val() == 0 && $('input[name="domini"]').val() == 0) {
        $('#currentMessage').text(translations.emptyDestination);
        $('#emptyErrorModal').modal('show');
        return false;
    }

    if ($('input[name="datapicker"]').val() == "" || $('input[name="datapickerOut"]').val() == "" || $('input[data-name="datePickerTextDesktop"]').val() == "" || $('input[data-name="datePickerTextMobile"]').val() == "") {
        $('#currentMessage').text(translations.emptyDate);
        $('#emptyErrorModal').modal('show');
        return false;
    }

    for (var i = 1; i <= 3; i++) {

        if(!$('div[data-name="holderHab'+i+'"]').hasClass('lg-opacity')){

            for (var j = 1; j <= 4; j++) {

                if(!$('div[data-name="holderNen'+i+''+j+'"]').hasClass('d-none') && $('#edat'+i+j).val() == ''){
                    error=1;
                }
            }
        }
    }

    if(error==1){
        $('#currentMessage').text(translations.emptyAge);
        $('#emptyErrorModal').modal('show');
        return false;
    }

    return true;
});

$(document).on('click' , '#modifyOpenDate' , function(){
    updateDatePickerTextDesktop(true,true);
});


//Si el email se ha enviado mostramos un modal informando
if($('#mailSent').val() == true) {
    $('#mailStatus').modal('show');
} else if($('#mailSent').val() == false){
    $('#mailStatus').modal('show');
} else if($('#mailSent').val() == 'error'){
    $('#mailStatus').modal('show');
}

//Mostrar el modal de validación tras enviar el form
if($('#showCheckFormModal').val()) {
    $('#checkFormModal').modal('show');
}

$('body').scrollspy({target: "#scrollSpyNav", offset: 50});


$('a[data-name="linksToMap"]').click(function () {
    var lat = $(this).attr("data-lat");
    var lng = $(this).attr("data-lng");
    setZoom(lat, lng, 15, "#fichaHotelMap");
});

if($("#hotelContent").length) {
    $(".domini-txt").val(txt_donde_ir($("input[name='zona']").val(),$("input[name='area']").val(),$("input[name='domini']").val(),$("input[name='moda']").val(),$("input[name='opt-radio-search']").val()));

    if($("#dataOpt").val() == '' && $("input[name='domini']").val() == 0 && $("input[name='moda']").val() == 'H'){
        $("input[name='opt_radio_search'][data-value='1']").parent().click();
        $('a[data-toggle="tab"][data-name="hotelTab"]').click();
        $('#cl-selectTab').val(1);
        $('#dataOpt').val('E');
        $('#dataModa').val('E');
    }
}



// Add smooth scrolling on all links inside the navbar
$("#navLinks a").on('click', function(event) {

  // Make sure this.hash has a value before overriding default behavior
  if (this.hash !== "") {

    // Prevent default anchor click behavior
    event.preventDefault();

    // Store hash
    var hash = this.hash;

    // Using jQuery's animate() method to add smooth page scroll
    // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
    $('html, body').animate({
      scrollTop: $(hash).offset().top
    }, 600, function(){

    // Add hash (#) to URL when done scrolling (default click behavior)
      window.location.hash = hash;
    });

  } // End if

    //Scroll horizontal para posicionarlo al inicio
    var mainSlider = $("#navLinks").find('.dragscroll');
    var leftPos = mainSlider.scrollLeft();
    mainSlider.animate({
        scrollLeft: leftPos - 1200
    }, 300);

});
//End scroll spy smooth animation


// * Move slider with left and right arrows * //
$(document).on('click','button[name="leftArrow"]', function() {
    var mainSlider = $(this).parent().parent().parent().parent().find('ul');
    var leftPos = mainSlider.scrollLeft();
    mainSlider.animate({
        scrollLeft: leftPos - 600
    }, 300);
});

$(document).on('click','button[name="rightArrow"]', function() {
    var mainSlider = $(this).parent().parent().parent().parent().find('ul');
    var leftPos = mainSlider.scrollLeft();
    mainSlider.animate({
        scrollLeft: leftPos + 600
    }, 300);
});

$('#scrollBottom').click(function () {
   $("html, body").animate({ scrollTop: $(this).offset().top }, 'slow');
});

//Animar enlaces ancla

$('a.ancla').click(function (e) {
    e.preventDefault();
    enlace = $(this).attr('href');
    $('html, body').animate({
        scrollTop: $(enlace).offset().top
    }, 1000);
});

//Fin Animar enlaces ancla


$(document).ready(function() {

    //Activamos el modal de deteccion de internet explorer 9 o inferior
    if($('#detectBrowser').length) {
        $('.modal').removeClass('fade');
        $('#detectBrowser').modal('show');
    }

    //Al pulsar el acordeon el + cambia por una x
    $('.collapse').on('show.bs.collapse', function () {
        var collapseheader = $(this).attr('aria-labelledby');
        var collapseSvg = $('#'+collapseheader).find('svg.rotator');
        collapseSvg.removeClass('rotate-icon');
        collapseSvg.addClass('rotate-iconOff');
    })
    $('.collapse').on('hide.bs.collapse', function () {
        var collapseheader = $(this).attr('aria-labelledby');
        var collapseSvg = $('#'+collapseheader).find('svg.rotator');
        collapseSvg.addClass('rotate-icon');
        collapseSvg.removeClass('rotate-iconOff');
    })

    $('.card').on('show.bs.collapse', function () {
        $(this).find('span[data-name="eurPersonText"]').removeClass("d-none");
        $(this).find('div[data-name="eurPersonButton"]').addClass("d-none");
        $(this).find('span[data-name="cabeceraForfait"]').removeClass("d-none");
        $(this).find('svg').removeClass("rotate-icon");
        $(this).find('svg').addClass("rotate-iconOff");
    });

    $('.card').on('hide.bs.collapse', function () {
        $(this).find('span[data-name="eurPersonText"]').addClass("d-none");
        $(this).find('span[data-name="cabeceraForfait"]').addClass("d-none");
        $(this).find('div[data-name="eurPersonButton"]').removeClass("d-none");
        $(this).find('svg.rotator').addClass("rotate-icon");
        $(this).find('svg.rotator').removeClass("rotate-iconOff");
    });

    addShadowMobileButtons();
    displaySelectOnChoice(1);
    $('span.force-checkmark').parent().addClass("shadow-xl");

    //Mostrar/Ocultar puntuación segmentada de los comentarios en la ficha del hotel
    $('button[name="commentScoreSegmented"]').click(function() {

        var button = $(this);
        var target = button.attr("data-target");

        $(target).on('hide.bs.collapse', function () {
            button.text(translations.segmented);
        });

        $(target).on('show.bs.collapse', function () {
            button.text(translations.hideSegmented);
        });

    });

    //Recalcular la altura del carousel al mostrar la puntuación segmentada
    $('.comment-score-box .collapse').on('shown.bs.collapse', function () {
        $('.cl-ctn-carousel-comments .main-carousel').flickity('resize');
    });

    //Recalcular la altura del carousel al mostrar la puntuación segmentada
    $('.comment-score-box .collapse').on('hidden.bs.collapse', function () {
        $('.cl-ctn-carousel-comments .main-carousel').flickity('resize');
    });

    //Mostrar ocultar detalles del hotel
    $('div[data-collapsable="fullText"]').on('show.bs.collapse', function (e) {
        clicked = $(this).parent().parent().find("[href='#" + $(e.target).attr('id') + "']")

        $('div[data-collapsable="hiddenText'+ $(e.target).attr('id')+'"]').addClass("d-none");
        clicked.text(translations.showLess);
    })

    $('div[data-collapsable="fullText"]').on('hide.bs.collapse', function (e) {
        clicked = $(this).parent().parent().find("[href='#" + $(e.target).attr('id') + "']")

       $('div[data-collapsable="hiddenText'+ $(e.target).attr('id')+'"]').removeClass("d-none");
        clicked.text(translations.showMore);
    })

    //Menu buscador mobil - Efecto sombreado navigation tabs
    $('a[data-toggle="tab"]').on('hidden.bs.tab', function (e) {

        if($(this).data('name') == 'hotelTab'){
            $('#cl-selectTab').val(0);
        }else{
            $('#cl-selectTab').val(1);
        }

        displaySelectOnChoice(1);

    })


    //Menu buscador mobil - Aplicar sombreado si esta marcado
    $('.mobile-checkbox-choose').click(function() {
        $('span.force-checkmark').removeClass("force-checkmark");
        addShadowMobileButtons();
        //Menu buscador mobil - Mostrar select según la opcíón escogida
        displaySelectOnChoice(2);
    });


    $('#minimalistSearch').on('click', function(event) {
        $('#searchOfferPopUp').modal('show');
    });

    $(document).on('show.bs.modal', '.modal', function (event) {
        var zIndex = 1040 + (10 * $('.modal:visible').length);
        $(this).css('z-index', zIndex);
        setTimeout(function() {
            $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
        }, 0);
    });


    //OnLoadScripts
    transformButtonOnScroll();
    if($('input[name="lodgingType"]').length) {
        /*loadEventOffers();*/
    }

    //Cargar más comentarios cuando llegas al final del scroll de los comentarios actuales
    $('.cl-ctn-carousel-comments .carousel').on( 'settle.flickity', function( event, index ) {

        var flkty = $(this).data('flickity');
        var last_pos_slides = flkty.slides.length - 1;

        //Miramos cuando llegamos al último slide
        if(index == last_pos_slides){

            //Borramos el loading
            var loading = $('#loading-comments');
            $(this).flickity('remove', loading);

            //Cargamos más comentarios
            var comments = ($('#moreComments').val() == 1)? loadAllComments() : null;

            if(comments != null && comments != ''){

                var $cellElems = $(comments);
                $(this).flickity( 'append', $cellElems );

                //Añadimos loading
                $(this).flickity( 'append', loading);

                //Pasamos al siguiente slider para poder ver lo que se ha cargado nuevo
                if(ancho > 1200){
                    var num_cells_slider = (ancho < 600)? 1 : 3;
                    $(this).flickity('selectCell', index * num_cells_slider);
                }

            }else{
                $('#moreComments').val(0);
            }

        }
    });
});

//Menu buscador - Efecto sombreado navigation tabs
$("ul.custom-nav-tab").find(".nav-item:has(a.active)").addClass("custom-nav-active-tab");
$("ul.custom-nav-tab-transparent").find(".nav-item:has(a.active)").addClass("custom-nav-active-tab-transparent");

$('a[data-toggle="tab"]').on('hidden.bs.tab', function (e) {
    $("ul.custom-nav-tab > .nav-item, a").not(".active").removeClass("custom-nav-active-tab");
    $("ul.custom-nav-tab > .nav-item:has(a.active)").addClass("custom-nav-active-tab");

    $("ul.custom-nav-tab-transparent > .nav-item, a").not(".active").removeClass("custom-nav-active-tab-transparent");
    $("ul.custom-nav-tab-transparent > .nav-item:has(a.active)").addClass("custom-nav-active-tab-transparent");
})

$("button[data-dismiss=selectSki]").click(function(){
    $('#selectSki').modal('hide');
});

$("li[data-dismiss=selectSki]").click(function(){
    $('#selectSki').modal('hide');
});

//Animacion de boton transformable al scrolear
$(function(){
  $(window).scroll(function(){
    transformButtonOnScroll();
  });
});

function transformButtonOnScroll() {
    if($('#buttonTransformSection').length)
    {
        if ($(window).scrollTop() > ($('#buttonTransformSection').offset().top + $('#buttonTransformSection').outerHeight() )) {
            $('#searchButtonTransformable').addClass('buttonSearchTransform');
            $('#searchButtonTransformable').removeClass('buttonSearchTransformOff');
            $('.mobile-housing-acordion').addClass('cl-ctn-mobile-acordion');
            $('.mobile-housing-acordion').removeClass('cl-ctn-mobile-acordionOff');

            //Ocultamos
            $('#searchTextTransformable').addClass('d-none');
            //Mostramos
            $('#searchSvgTransformable').removeClass('d-none');

            //Solo para esquicom
            if($('#telfAnimationIcon').length && !$('.buscador').hasClass('d-none')){
                $('#telfAnimationIcon').addClass('buttonSearchPadding');
            }

        }else if ($(window).scrollTop() <= ($('#buttonTransformSection').offset().top + $('#buttonTransformSection').outerHeight() )) {
            $('#searchButtonTransformable').removeClass('buttonSearchTransform');
            $('#searchButtonTransformable').addClass('buttonSearchTransformOff');
            $('.mobile-housing-acordion').removeClass('cl-ctn-mobile-acordion');
            $('.mobile-housing-acordion').addClass('cl-ctn-mobile-acordionOff');

            //Mostramos
            $('#searchTextTransformable').removeClass('d-none');
            //Ocultamos
            $('#searchSvgTransformable').addClass('d-none');

            //Solo para esquicom
            if($('#telfAnimationIcon').length){
                $('#telfAnimationIcon').removeClass('buttonSearchPadding');
            }
        }

        if ($(window).scrollTop() > ($('#buttonTransformSection').offset().top)) {
            $('#searchButtonSticky').addClass('buttonSearchSticky');
        } else {
            $('#searchButtonSticky').removeClass('buttonSearchSticky');
        }
    }
}

$('#btn-mostrar-buscador').click(function () {
    $('.cl-ocultar-buscador-movil').show();
    $('.clCtnMostrarBuscadorMv').hide();
    $('#telfAnimationIconOff').attr('id', 'telfAnimationIcon');
    $('#ctn-buscador-movil').addClass('bg-custom-black').addClass('mb-3-rem');
    $('#ctn-tit-buscador-movil').removeClass('mb-2').addClass('mb-4');
    $('#ctn-tit-buscador-movil h1').addClass('text-white');
    $('html, body').animate({
        scrollTop: $('header').offset().top - 43
    }, 300);
});

function loadAllComments()
{

    var result = null;
    var nComments = 50;
    var posLastItem = $('#nComments').val();

    $.ajaxSetup({
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        }
    });

    $.ajax({
        type:'POST',
        url: APP_URL+'/ajax/getHousingComments',
        data: {
            housingType: $('input[name="lodgingType"]').val(),
            housingCode: $('input[name="lodgingId"]').val(),
            housingLang: $('input[name="idioma"]').val(),
            nComments: nComments,
            posLastItem: posLastItem,
            ajax: true
        },
        async: false,
        success: function(data){

            var comments = $(data).find('.carousel-cell');
            if (comments != '') {

                result = data;

                var new_pos = parseInt(posLastItem) + parseInt(nComments);
                $('#nComments').val(new_pos);
            }
        }
    });

    return result;

}

function addShadowMobileButtons() {
    $('.mobile-checkbox-choose').removeClass("shadow-xl");
    $('input[name="opt_radio_search"]:checked').parent().addClass("shadow-xl");
}

function displaySelectOnChoice(evento)
{

    //CODIGO PARA ELEGIR MANUALMENTE DESDE EL SELECT
    if ($('a[data-name="hotelAndActivityTab"]').hasClass("active")) {

        var radioValue = $("input[name='opt_radio_search']:checked").attr('data-value');

        if(radioValue == null){
            $('li[data-value=' + $("input[name='domini']").val() + ']').each(function( index ) {
                if($(this).data('name') == 'domini' && $(this).data('moda') == $("input[name='moda']").val() && $(this).data('zona') == $("input[name='zona']").val() && $(this).data('area') == $("input[name='area']").val()){

                    switch ($(this).data('opt')) {
                      case "E":
                            $("input[name='opt_radio_search'][data-value='1']").parent().click();
                        break;
                      case "R":
                            $("input[name='opt_radio_search'][data-value='2']").parent().click();
                        break;
                      case "A":
                            $("input[name='opt_radio_search'][data-value='3']").parent().click();
                        break;
                      case "B":
                            $("input[name='opt_radio_search'][data-value='3']").parent().click();
                        break;
                      case "P":
                            $("input[name='opt_radio_search'][data-value='4']").parent().click();
                        break;
                    }

                }
            });
        }

        if(evento == 2){

            $('input[name="zona"]').val($('#dataZonahotel').val());
            $('input[name="domini"]').val(0);
            $('input[name="area"]').val(0);
            $('#dataZonahotelA').val(0);
            $('#dataAreahotelA').val(0);
            $('#dataDominiohotelA').val(0);
            $('.domini-txt').val($('#dataZonahotel_txt').val());

            var zona = $('#dataZonahotel').val();

        }else{

            var zona = $('#dataZonahotelA').val();

        }

        var area = $('#dataAreahotelA').val();
        var domini = $('#dataDominiohotelA').val();
        var opt = $('#dataOpt').val();
        var moda = $('#dataModa').val();

        //Ocultamos selects
        $('#skiSelect').addClass("d-none");
        $('#relaxSelect').addClass("d-none");
        $('#soloRelaxSelect').addClass("d-none");
        $('#adventureSelect').addClass("d-none");
        $('#parksSelect').addClass("d-none");
        $('#soloHotelSelect').addClass("d-none");

        switch (radioValue) {
          case "1":
            $('#skiSelect').removeClass("d-none");
            $('label[data-name="labelSkiText"]').text(translations.whereSki);
            var moda = 'E';
            var opt = 'E';
            break;
          case "2":
            $('#relaxSelect').removeClass("d-none");
            $('label[data-name="labelSkiText"]').text(translations.selectSpa);
            var moda = 'H';
            var opt = 'R';
            break;
          case "3":
            $('#adventureSelect').removeClass("d-none");
            $('label[data-name="labelSkiText"]').text(translations.selectAdventure);
            if(moda != 'B'){
                var moda = 'H';
                var opt = 'A';
            }else{
                var moda = 'B';
                var opt = 'B';
            }
            break;
          case "4":
            $('#parksSelect').removeClass("d-none");
            $('label[data-name="labelSkiText"]').text(translations.selectPark);
            var moda = 'H';
            var opt = 'P';
            break;
        default:
            $('#skiSelect').removeClass("d-none");
            $('label[data-name="labelSkiText"]').text(translations.whereSki);
            var moda = 'E';
            var opt = 'E';
        }

        $('input[name="zona"]').val(zona);
        $('input[name="area"]').val(area);
        $('input[name="domini"]').val(domini);
        $('input[name="opt_radio_search"]').val(opt);
        $('input[name="moda"]').val(moda);
        $('#dataOpt').val(opt);
        $('#dataModa').val(moda);
    }

    if($('#cl-selectTab').val() == 1) {
        $('input[name="domini"]').val(0);

        var zona = $('#dataZonahotel').val();
        $('input[name="zona"]').val(zona);
        $('input[name="area"]').val(0);

        $('input[name="moda"]').val('H');
        $('input[name="esquiverano"]').val(0);
        $('input[name="tematica"]').val(0);
        $('input[name="opt_radio_search"]').val('SH');
    }
}

/*--- SEARCHER ---*/

//Eliminar el buscador que no se use en función del tamaño de la pantalla

if(ancho < 1200){
    $('.cl-movil-modal.cl-searcher-desktop').remove();
}else{
    $('.cl-movil-modal.cl-searcher-modal').remove();
}

if(ancho <= 576){
    $('#datePickerTextDesktop').remove();
    $('#datePickerTextMobile').show();
}else{
    $('#datePickerTextMobile').remove();
}

//Botones acción slider y options

function cambiar_datos_searcher(data_moda, data_tematica, data_opt_radio_search, data_tipop, data_in_tour){

    //valores para action y modal dominio
    var data_modal_domini = "";
    var data_url = "";

    switch(data_opt_radio_search) {
        case 'E':
            data_modal_domini = "#skiSelect";
            data_url = "booking";
            break;
        case 'SF':
            data_modal_domini = "#forfaitSelect";
            data_url = "actividades";
            break;
        case 'R':
            data_modal_domini = "#relaxSelect";
            data_url = "booking";
            break;
        case 'SR':
            data_modal_domini = "#soloRelaxSelect";
            data_url = "actividades";
            break;
        case 'A':
            data_modal_domini = "#adventureSelect";
            data_url = "booking";
            break;
        case 'SA':
            data_modal_domini = "#adventureSelect";
            data_url = "actividades";
            break;
        case 'B':
            data_modal_domini = "#adventureSelect";
            data_url = "booking";
            break;
        case 'SB':
            data_modal_domini = "#adventureSelect";
            data_url = "actividades";
            break;
        case 'SH':
            data_modal_domini = "#soloHotelSelect";
            data_url = "booking";
            break;
        case 'P':
            data_modal_domini = "#parksSelect";
            data_url = "booking";
            break;
        case 'SP':
            data_modal_domini = "#parksSelect";
            data_url = "actividades";
            break;
    }

    //cambiar valores hiddens
    $("input[name='moda']").val(data_moda);
    $("input[name='tematica']").val(data_tematica);
    $("input[name='opt_radio_search']").val(data_opt_radio_search);
    $("input[name='tipoP']").val(data_tipop);
    $("#in_Tour").val(data_in_tour);

    if($('#ctnSearcherForm').hasClass('cl-searcher-ficha')){

        //mostrar el nombre del hotel o el select dominios
        if(data_opt_radio_search == 'SH'){
            $('#ctn-nombre-hotel').show();
            $('#ctn-dominitxt').hide();
        }else{
            $('#ctn-nombre-hotel').hide();
            $('#ctn-dominitxt').show();
        }

    }

    //cambiar el valor para saber que modal abrir
    $('#skiSelect').addClass("d-none");
    $('#relaxSelect').addClass("d-none");
    $('#soloRelaxSelect').addClass("d-none");
    $('#adventureSelect').addClass("d-none");
    $('#parksSelect').addClass("d-none");
    $('#forfaitSelect').addClass("d-none");
    $('#soloHotelSelect').addClass("d-none");

    $(data_modal_domini).removeClass("d-none");

    switch(data_modal_domini) {
      case '#skiSelect':
        $('#ctn-modal-dominitxt label').text(translations.whereSki);
        $('#ctn-title-searcher').text(translations.titleSearcherEsqui);
        $('#ctn-datePickerTextDesktop label').text(translations.titleDates);
        break;
      case '#relaxSelect':
        $('#ctn-modal-dominitxt label').text(translations.selectSpa);
        $('#ctn-title-searcher').text(translations.titleSearcherRelax);
        $('#ctn-datePickerTextDesktop label').text(translations.titleDates);
        break;
      case '#soloRelaxSelect':
        $('#ctn-modal-dominitxt label').text(translations.selectSpa);
        $('#ctn-title-searcher').text(translations.titleSearcherRelax);
        $('#ctn-datePickerTextDesktop label').text(translations.titleDate);
        break;
      case '#adventureSelect':
        $('#ctn-modal-dominitxt label').text(translations.selectAdventure);
        $('#ctn-title-searcher').text(translations.titleSearcherAventura);
        if(data_opt_radio_search == 'SA'){
            $('#ctn-datePickerTextDesktop label').text(translations.titleDate);
        }else{
            $('#ctn-datePickerTextDesktop label').text(translations.titleDates);
        }
        break;
      case '#parksSelect':
        $('#ctn-modal-dominitxt label').text(translations.selectPark);
        $('#ctn-title-searcher').text(translations.titleSearcherPark);
        $('#ctn-datePickerTextDesktop label').text(translations.titleDates);
        break;
      case '#soloHotelSelect':
        $('#ctn-modal-dominitxt label').text(translations.selectHotel);
        $('#ctn-title-searcher').text(translations.titleSearcherHotel);
        $('#ctn-datePickerTextDesktop label').text(translations.titleDates);
        break;
    }

    //cambiar action del form
    var url = "";

    if(data_url == 'booking'){
        url = $('#url_booking').val();
    }else{
        url = $('#url_actividades').val();
    }

    $('#searcherForm').attr("action",url);

}

//FUNCIONALIDAD SEE MORE: Muestra numero de elementos definido en el div padre y btn para ir mostrando más elementos
function runSeeMore(start = 0, filter = 0, obj = null){

    if(ancho >= 992){
        var width_txt = 'lg';
    }else if(ancho >= 576){
        var width_txt = 'sm';
    }else{
        var width_txt = 'base';
    }

    //Al iniciar
    if(start == 1){

        if(filter == 1){

            $('.cl-seeMoreBtn', obj).show();

            let num_elem = obj.data(width_txt);
            let count = 0;
            let num_all_elem = 0;

            //Contamos los elementos totales del filtro en cuestión
            $('.cl-seeMoreElem', obj).each(function(){

                if($(this).is(':visible')){

                    if(count < num_elem){
                        $(this).show();
                        count++;
                    }else{
                        $(this).hide();
                    }

                    num_all_elem++;
                }

            });

            //Ocultar el btn si no hay más elementos ocultos
            if(num_all_elem == count){
                $('.cl-seeMoreBtn', obj).hide();
            }

        }else{

            //Recorremos todos los div con la funcionalidad
            $('.cl-seeMoreCtn').each(function(){

                let num_elem = $(this).data(width_txt);
                let count = 0;
                let num_all_elem = $('.cl-seeMoreElem', this).length;
                let main_parent = $(this);

                //Mostramos el numero de elementos ocultos de inicio definidos segun ancho pantalla
                $('.cl-seeMoreElem', this).each(function(){

                    if(count < num_elem){
                        $(this).show();
                        count++;
                    }else{
                        return false;
                    }

                    //Ocultar el btn si no hay más elementos ocultos
                    if(num_all_elem == count){
                        $('.cl-seeMoreBtn',main_parent).hide();
                    }

                });
            });

            //Evento para el btn see more
            $('.cl-seeMoreBtn').click(function () {
                runSeeMore(0,0,this);
            });
        }

    //Al hacer click en el btn
    }else{

        let main_parent = jQuery(obj).parent().parent('.cl-seeMoreCtn');
        let has_filter = main_parent.hasClass('cl-filterCtn');
        let num_elem = main_parent.data(width_txt);
        let count_all = 0;
        let count = 0;

        if(has_filter > 0){

            let num_all_elem = 0;
            let filterActive = $('.cl-filterBtn.active', main_parent).data('filter');

            //Contamos el numero de elementos de ese filtro
            $('.cl-seeMoreElem', main_parent).each(function(){

                if(filterActive == ''){
                    num_all_elem++;
                }else if(filterActive == $(this).data('filter')){
                    num_all_elem++;
                }
            });

            //Mostramos el numero de elementos ocultos definidos segun ancho pantalla y por filtro
            $('.cl-seeMoreElem', main_parent).each(function(){

                if(filterActive == $(this).data('filter') || filterActive == ''){
                    count_all++;
                }

                if(count < num_elem){

                    if(!$(this).is(':visible') && (filterActive == $(this).data('filter') || filterActive == '')){

                        $(this).show();
                        count++;
                    }

                }else{
                    return false;
                }

                //Ocultar el btn si no hay más elementos ocultos
                if(num_all_elem == count_all){
                    $('.cl-seeMoreBtn', main_parent).hide();
                }

            });

        }else{

            let num_all_elem = $('.cl-seeMoreElem', main_parent).length;

            //Mostramos el numero de elementos ocultos definidos segun ancho pantalla
            $('.cl-seeMoreElem', main_parent).each(function(){

                count_all++;

                if(count < num_elem){

                    if(!$(this).is(':visible')){

                        $(this).show();
                        count++;
                    }

                }else{
                    return false;
                }

                //Ocultar el btn si no hay más elementos ocultos
                if(num_all_elem == count_all){
                    $('.cl-seeMoreBtn', main_parent).hide();
                }

            });
        }
    }
}

//FUNCIONALIDAD FILTRAR
function runFilter(){

    //Recorremos todos los div con la funcionalidad
    $('.cl-filterCtn').each(function(){

        let has_carousel = $('.carousel', this).length;
        let has_seeMore = $('.cl-seeMoreBtn', this).length;

        //Evento para los btns de filtrado
        $('.cl-filterBtn', this).click(function () {

            let filterData = $(this).data('filter');
            // let main_parent = $(this).parent().parent(); // susceptible a errores al depender de una estructura en concreto
            let main_parent = $(this).closest('.cl-filterCtn'); // Busca recursivamente los parents hasta encontrar uno con ésta clase

            $(this).siblings().removeClass('active');
            $(this).addClass('active');

            $('.cl-filterElem', main_parent).each(function(){

                if(filterData == ''){

                    $(this).show();

                    if(has_carousel > 0 && !$(this).hasClass('carousel-cell')){
                        $(this).addClass('carousel-cell');
                    }

                }else{

                    if(filterData == $(this).data('filter')){

                        $(this).show();

                        if(has_carousel > 0 && !$(this).hasClass('carousel-cell')){
                            $(this).addClass('carousel-cell');
                        }

                    }else{

                        $(this).hide();

                        if(has_carousel > 0 && $(this).hasClass('carousel-cell')){
                            $(this).removeClass('carousel-cell');
                        }
                    }
                }
            });

            if(has_seeMore > 0){
                runSeeMore(1,1,main_parent);
            }

            if(has_carousel > 0){
                $('.carousel', main_parent).flickity('resize');
                $('.carousel', main_parent).flickity('select', 0);
            }

        });
    });
}

$('#ctnSearcherForm .cl-ctn-searcher .carousel-tematicas .carousel-cell').click(function () {

    $("input[name='area']").val(0);
    $("input[name='domini']").val(0);

    $('#ctnSearcherForm .cl-ctn-searcher .carousel-tematicas .active').removeClass('active');
    $(this).addClass('active');

    $('#ctnSearcherForm .cl-ctn-searcher .cl-ctn-options .cl-options').hide();
    $('#options_' + $(this).data('options')).show();

    $('#ctnSearcherForm .cl-ctn-searcher .cl-ctn-options input').removeAttr("checked");
    $('#ctnSearcherForm .cl-ctn-searcher .cl-ctn-options .cl-options-sin-slider input:first-child').prop("checked", true);
    $('#ctnSearcherForm .cl-ctn-searcher .cl-ctn-options .cl-options-con-slider .slide:first-child input').prop("checked", true);

    var opcion_sel = $('#options_' + $(this).data('options') + ' input:first-child');
    cambiar_datos_searcher(opcion_sel.data('moda'), opcion_sel.data('tematica'), opcion_sel.data('opt-radio-search'), opcion_sel.data('tipop'), opcion_sel.data('in-tour'));

    //Reiniciar el calendario del buscador
    startDateRangePickerSearcher(opcion_sel.data('moda'),true);

    $("#btn-dominitxt").val(txt_donde_ir($("input[name='zona']").val(),$("input[name='area']").val(),$("input[name='domini']").val(),$("input[name='moda']").val(),$("input[name='opt_radio_search']").val()));

});

$('#ctnSearcherForm .cl-ctn-searcher .cl-ctn-options input').click(function () {

    $("input[name='area']").val(0);
    $("input[name='domini']").val(0);

    cambiar_datos_searcher($(this).data('moda'), $(this).data('tematica'), $(this).data('opt-radio-search'), $(this).data('tipop'), $(this).data('in-tour'));

    //Reiniciar el calendario del buscador
    startDateRangePickerSearcher($(this).data('moda'),true);

    $("#btn-dominitxt").val(txt_donde_ir($("input[name='zona']").val(),$("input[name='area']").val(),$("input[name='domini']").val(),$("input[name='moda']").val(),$("input[name='opt_radio_search']").val()));

});
//Actualizamos los datos del buscador
cambiar_datos_searcher($("input[name='moda']").val(), $("input[name='tematica']").val(), $("input[name='opt_radio_search']").val(), $("input[name='tipoP']").val(), $("#in_Tour").val());
$("#btn-dominitxt").val(txt_donde_ir($("input[name='zona']").val(),$("input[name='area']").val(),$("input[name='domini']").val(),$("input[name='moda']").val(),$("input[name='opt_radio_search']").val()));

//Acciones en inputs form searcher

$('#ctn-modal-dominitxt').click(function () {
    $('#selectSki').modal('show');
});

$('#ctn-datePickerTextDesktop').click(function () {
    updateDatePickerTextDesktop();
});

$('#ctn-nPpeople').click(function () {
    $('#nPpeople').modal('show');
});

//FUNCIONALIDAD SEE MORE
//Mostramos el numero inicial de elementos segun ancho de pantalla
runSeeMore(1);

//FUNCIONALIDAD FILTRAR
runFilter();
